import { AlarmsState } from "@/store/alarms/types"
import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import { RootState } from "@/store"
import { AlarmAnchorType, AlarmData, anchorTypeEndpoints } from "@/types/alarm"
import axios from "axios"

const state: AlarmsState = {
    loading: false,
    alarms: [],
    counts: { byLevel: { INFO: 0, WARNING: 0, CRITICAL: 0 }, total: 0 },
}

const mutations: MutationTree<AlarmsState> = {
    setLoading(state, loading: boolean) {
        state.loading = loading
    },
    setAlarms: (state, alarms: AlarmsState["alarms"]) => {
        state.alarms = alarms
    },
    setCounts: (state, counts: AlarmsState["counts"]) => {
        state.counts = counts
    },
}

const actions: ActionTree<AlarmsState, RootState> = {
    async fetchAlarmsForType(
        { commit },
        {
            type,
            id,
            signal,
        }: { type: AlarmAnchorType; id: number | string; signal?: AbortSignal },
    ) {
        commit("setLoading", true)

        try {
            const res = await axios.get<AlarmData>(
                `/v2/${anchorTypeEndpoints[type]}/${id}/alarms/active`,
                { signal },
            )

            commit("setAlarms", res.data.data.alarms)
            commit("setCounts", res.data.data.counts)
            commit("setLoading", false)
        } catch (e) {
            if (axios.isCancel(e)) return
            console.error("Error while fetching alarms", e)
            commit("setLoading", false)
        }
    },
}

const getters: GetterTree<AlarmsState, RootState> = {
    alarms: ({ alarms }) => alarms,
    loading: ({ loading }) => loading,
    counts: ({ counts }) => counts,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
} as Module<AlarmsState, RootState>
